import * as React from "react";
const SvgVideoCamera = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4418_7165)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.4 8.95552C22.7246 8.61324 21.9133 8.68458 21.308 9.1395L19.475 10.5005C19.2151 7.94714 17.0666 6.00375 14.5 6.00052H14.415L10.293 1.8795C9.73208 1.31461 8.96816 0.998018 8.17203 1.0005H1.49998C0.947703 1.0005 0.5 1.44825 0.5 2.00053C0.5 2.55282 0.947703 3.00052 1.49998 3.00052H8.17198C8.43706 3.00122 8.69112 3.1065 8.879 3.29353L11.586 6.00052H5.50002C2.73997 6.00385 0.503328 8.24049 0.5 11.0005V19.0006C0.503328 21.7606 2.73997 23.9972 5.50002 24.0005H14.5C17.0666 23.9973 19.2151 22.0539 19.475 19.5005L21.305 20.8645C22.1886 21.5273 23.4423 21.3482 24.105 20.4646C24.3646 20.1184 24.505 19.6973 24.505 19.2646V10.7435C24.5076 9.9856 24.0791 9.29218 23.4 8.95552ZM17.5 19.0005C17.5 20.6573 16.1569 22.0005 14.5 22.0005H5.50002C3.84317 22.0005 2.50002 20.6573 2.50002 19.0005V11.0005C2.50002 9.34369 3.84317 8.00054 5.50002 8.00054H14.5C16.1569 8.00054 17.5 9.34369 17.5 11.0005V19.0005ZM22.5 19.2575L19.5 17.0215V12.9796L22.5 10.7436V19.2575Z",
      fill: "#1B1C1D"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4418_7165" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0.5)" })))
);
export default SvgVideoCamera;
